import CityPageTemplate from "../city-template/CityPageTemplate";
import { boulderCityConfig } from "./data";

export default function BoulderCityPage() {
  return <CityPageTemplate config={boulderCityConfig} />;
}